<app-pcard-reload-button *ngIf="headerOption.refreshButton"></app-pcard-reload-button>

<app-pcard-edit-column-button *ngIf="headerOption.editColumnButton"></app-pcard-edit-column-button>

<app-pcard-print-button *ngIf="headerOption.printButton"></app-pcard-print-button>

<app-pcard-create-button *ngIf="headerOption.createButton"></app-pcard-create-button>

<app-pcard-help-button *ngIf="headerOption.helpButton"></app-pcard-help-button>